var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.5H11V1.5H10V2.5H6V1.5H5V2.5H3C2.44667 2.5 2 2.94667 2 3.5V13.5C2 14.0533 2.44667 14.5 3 14.5H13C13.5533 14.5 14 14.0533 14 13.5V3.5C14 2.94667 13.5533 2.5 13 2.5ZM13 13.5H3V6.5H13V13.5ZM13 5.5H3V3.5H5V4.5H6V3.5H10V4.5H11V3.5H13V5.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSchedule);
export default __webpack_public_path__ + "static/media/ic-schedule.e008c53d7fee90e424328a90dc65ccbe.svg";
export { ForwardRef as ReactComponent };